/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:23/01/2021
 @Time:08:48
 **/

import Logger from "js-logger";

export default class JsLogger {

    /**
     * indique si la méthode configure est appellé
     * @type {boolean}
     */
    static configured = false;

    /**
     * Configure logger based on begro env
     */
    static configure() {
        if (!JsLogger.configured) {
            Logger.useDefaults({
                defaultLevel: Begro.env !== "dev" ? Logger.WARN: Logger.DEBUG,
                formatter: function (messages, context) {
                    messages.unshift(new Date().toUTCString())
                }
            });
            JsLogger.configured=true;
        }
    }


    /**
     *
     * @param message log info message
     */
    static info(message) {
        JsLogger.configure();
        Logger.info(message);
    }

    /**
     *
     * @param message log error message
     */
    static error(message) {
        JsLogger.configure();
        Logger.error(message);
    }

    /**
     *
     * @param message log warning message
     */
    static warning(message) {
        JsLogger.configure();
        Logger.warning(message);
    }


    /**
     *
     * @param message log warning message
     */
    static trace(message) {
        JsLogger.configure();
        Logger.trace(message);
    }

    /**
     *
     * @param message log warning message
     */
    static debug(message) {
        JsLogger.configure();
        Logger.debug(message);
    }


}